import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { StoreDetailsProvider } from './StoreDetailsProvider/StoreDetailsProvider';
import { CustomerReservationProvider } from './CustomerReservationProvider/CustomerReservationProvider';
import { VehicleReservationProvider } from './VehicleReservationProvider/VehicleReservationProvider';
import { CustomSnackbarProvider } from './SnackbarProvider/CustomSnackbarProvider';
import { CustomStripeProvider } from './CustomStripeProvider/CustomStripeProvider';
import { MenuValuesProvider } from './MenuValuesProvider/MenuValuesProvider';
import { ResponsiveValuesProvider } from './DimentionsProvider/ResponsiveValuesProvider';
import { ManageKeysProvider } from './ManageKeysProvider/ManageKeysProvider';
import { CmsEditProvider } from '../../cms/CmsEditProvider';

interface Props {
  children: React.ReactNode;
}

const Providers = ({ children }: Props) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <CmsEditProvider>
    <StoreDetailsProvider>
      <ManageKeysProvider>
        <CustomerReservationProvider>
          <VehicleReservationProvider>
            <CustomSnackbarProvider>
              <CustomStripeProvider>
                <MenuValuesProvider>
                  <ResponsiveValuesProvider>
                    {children}
                  </ResponsiveValuesProvider>
                </MenuValuesProvider>
              </CustomStripeProvider>
            </CustomSnackbarProvider>
          </VehicleReservationProvider>
        </CustomerReservationProvider>
      </ManageKeysProvider>
    </StoreDetailsProvider>
    </CmsEditProvider>
  </LocalizationProvider>
);

export default Providers;

